import axios from 'axios';
import { openAlert } from '../Redux/Slices/alertSlice';
import { successProdutoList,setLoading } from '../Redux/Slices/produtoSlice';

const BASE_URL = process.env.REACT_APP_API_URL;

const baseUrl = `${BASE_URL}/produto`;

export const getListProduto = async (dispatch) =>{
  dispatch(setLoading(true));
	try {
		const res = await axios.get(baseUrl);    
		dispatch(successProdutoList(res.data));
		setTimeout(() => {
			dispatch(setLoading(false));
		}, 300);
	} catch (error) {
		dispatch(setLoading(false));
		dispatch(
			openAlert({
				message: error?.response?.data?.errMessage ? error.response.data.errMessage : error.message,
				severity: 'error',
			})
		);
	}

}